import { useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useStableCallback = <T extends (...args: any[]) => unknown>(
  cb?: T
) => {
  const callbackRef = useRef<T | undefined>(cb);
  // keep the callback ref upto date
  callbackRef.current = cb;
  /**
   * initialize a persistent callback which never changes
   * through out the component lifecycle
   */
  const persistentCallbackRef = useRef<T>(((...args: Parameters<T>) => {
    return callbackRef.current?.(...args);
  }) as T);

  return persistentCallbackRef.current;
};
